<template>
  <div>
    <div style="height: 54px" class="sub-nav-box">
      <!-- judul halaman -->
      <h2 v-if="listNonPengguna">Manajemen Pengguna</h2>
    </div>

    <div style="padding: 0px 30px" class="container">
      <div class="table-navigation">
        <!-- filter -->
        <div class="list-filter">
          <!-- filter Divisi-->
          <div style="margin-right: 12px" class="filter-pilihan">
            <div @click="openClosePilihanDivisi(true)" class="filter">
              <!-- tipe filter -->
              <p>Divisi :</p>
              <!-- value filter -->
              <span>{{ filterData.divisi }}</span>
              <!-- icon filter -->
              <svg
                width="10"
                height="7"
                viewBox="0 0 10 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <!-- box pilihan filter -->
            <div
              style="margin-top: 2px; display: none"
              ref="boxPilihanDivisi"
              class="box-pilihan"
            >
              <p
                @click="openClosePilihanDivisi(false, divisi)"
                :key="divisi"
                v-for="divisi in listDivisi"
              >
                {{ divisi }}
                <svg
                  v-if="filterData.divisi === divisi"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan filter -->
          </div>
          <!-- end of filter Divisi-->
        </div>

        <!-- bagian untuk cari dan tambah -->
        <div class="cari-tambah-download">
          <!-- box pencarian -->
          <div class="cari">
            <svg
              style="margin-right: 8px"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <input
              v-model="filterData.pencarian"
              placeholder="Cari"
              type="text"
              name=""
              id=""
            />
          </div>
          <!-- button tambah -->
          <button @click="openCLoseModalInput(true)" class="add">
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8569 13.4284V11.9999C11.8569 11.2421 11.5558 10.5154 11.02 9.97956C10.4842 9.44374 9.75748 9.14272 8.99972 9.14272H3.99972C3.24196 9.14272 2.51523 9.44374 1.97942 9.97956C1.4436 10.5154 1.14258 11.2421 1.14258 11.9999V13.4284M14.714 4.14272V8.42843M16.8569 6.28557H12.5712M9.35686 3.42843C9.35686 5.00639 8.07768 6.28557 6.49972 6.28557C4.92176 6.28557 3.64258 5.00639 3.64258 3.42843C3.64258 1.85048 4.92176 0.571289 6.49972 0.571289C8.07768 0.571289 9.35686 1.85048 9.35686 3.42843Z"
                stroke="#FCFCFC"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- open menu mobile -->
          <div class="open-menu-mobile">
            <!-- menu icon -->
            <svg
              @click="openCloseMenuMobile(true)"
              width="14"
              height="4"
              viewBox="0 0 14 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <!-- end of menu icon -->

            <div
              style="display: none"
              ref="box-pilihan-menu"
              class="box-pilihan-aksi"
            >
              <!-- buka menu filter -->
              <p @click="openCloseFilterMobile(true)">
                <svg
                  width="17"
                  height="15"
                  viewBox="0 0 17 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                    stroke="#4E4B66"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Filter
              </p>
              <!-- tambah karyawan -->
              <p @click="openCLoseModalInput(true)">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.00003 5.14265V10.8569M5.14289 7.99979H10.8572M15.1429 7.99979C15.1429 11.9447 11.9449 15.1426 8.00003 15.1426C4.05514 15.1426 0.857178 11.9447 0.857178 7.99979C0.857178 4.0549 4.05514 0.856934 8.00003 0.856934C11.9449 0.856934 15.1429 4.0549 15.1429 7.99979Z"
                    stroke="#FFB700"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Tambah
              </p>
            </div>
          </div>
          <!-- end of open menu mobile -->
        </div>
        <!-- end of bagian untuk cari dan tambah -->
      </div>

      <!-- filter mobile -->
      <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
        <div class="filter-mobile">
          <div class="filter-mobile-title">
            <h5>
              Filter <br />
              Shifting
            </h5>
            <!-- close filter -->
            <svg
              @click="openCloseFilterMobile(false)"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
                stroke="#1A1A1A"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- input divisi -->
          <div class="keterangan input-keterangan">
            <div
              @click="openClosePilihanDivisiMobile(true)"
              ref="keterangan-form"
              class="box-form email"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="filterData.divisi"
                  style="display: block"
                  class="input-title"
                  >Divisi</span
                >
                <p>
                  {{ filterData.divisi ? filterData.divisi : "Divisi" }}
                </p>
              </div>
            </div>
            <!-- box pilihan divisi -->
            <div
              style="display: none"
              ref="boxPilihanDivisiMobile"
              class="box-pilihan"
            >
              <p
                @click="openClosePilihanDivisiMobile(false, divisi)"
                v-for="divisi in listDivisi"
                :key="divisi"
              >
                {{ divisi }}
                <svg
                  v-if="divisi === filterData.divisi"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan divisi -->
          </div>
          <!-- end of input divisi -->

          <div class="button-container">
            <button @click="openCloseFilterMobile(false)" class="yellow-button">
              Terapkan
            </button>
          </div>
        </div>
      </div>
      <!-- end of filter mobile -->

      <!-- tabel -->
      <div class="box-table">
        <table>
          <!-- judul tabel  -->
          <tr>
            <th style="width: 30%">Nama Karyawan</th>
            <th style="width: 30%">Email</th>
            <th style="width: 20%">Divisi</th>
            <th style="width: 20%">Aksi</th>
          </tr>
          <!-- start iterasi tabel -->
          <tr :key="pengguna.docId" v-for="(pengguna, index) in listPengguna">
            <!-- Nama Karyawan  -->
            <td>
              <span style="color: #1d1d1d; font-weight: 700">{{
                pengguna.data.dataDiri.namaLengkap
              }}</span>
            </td>
            <!-- email  -->
            <td>{{ pengguna.data.email }}</td>
            <!-- Divisi  -->
            <td>{{ pengguna.data.dataKepegawaian.divisi }}</td>

            <!-- action  -->
            <td style="padding-left: 32px; position: relative">
              <svg
                @click="openCloseAction(true, index)"
                width="14"
                height="4"
                viewBox="0 0 14 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99993 2.7147C7.39442 2.7147 7.71422 2.39491 7.71422 2.00042C7.71422 1.60593 7.39442 1.28613 6.99993 1.28613C6.60544 1.28613 6.28564 1.60593 6.28564 2.00042C6.28564 2.39491 6.60544 2.7147 6.99993 2.7147Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9999 2.7147C12.3944 2.7147 12.7142 2.39491 12.7142 2.00042C12.7142 1.60593 12.3944 1.28613 11.9999 1.28613C11.6054 1.28613 11.2856 1.60593 11.2856 2.00042C11.2856 2.39491 11.6054 2.7147 11.9999 2.7147Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.99993 2.7147C2.39442 2.7147 2.71422 2.39491 2.71422 2.00042C2.71422 1.60593 2.39442 1.28613 1.99993 1.28613C1.60544 1.28613 1.28564 1.60593 1.28564 2.00042C1.28564 2.39491 1.60544 2.7147 1.99993 2.7147Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div
                style="display: none; width: 158px"
                ref="box-pilihan-aksi"
                class="box-pilihan-aksi"
              >
                <p @click="openClosePasswordModal(true, pengguna.data.email)">
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.42855 7.28599V4.42885C3.42855 3.48165 3.80483 2.57324 4.4746 1.90347C5.14437 1.2337 6.05278 0.857422 6.99998 0.857422C7.94718 0.857422 8.85559 1.2337 9.52536 1.90347C10.1951 2.57324 10.5714 3.48165 10.5714 4.42885V7.28599M1.99998 7.28599H12C12.789 7.28599 13.4286 7.92559 13.4286 8.71456V13.7146C13.4286 14.5035 12.789 15.1431 12 15.1431H1.99998C1.211 15.1431 0.571411 14.5035 0.571411 13.7146V8.71456C0.571411 7.92559 1.211 7.28599 1.99998 7.28599Z"
                      stroke="#FFB700"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  Reset password
                </p>
                <p @click="openCloseEditModal(true)">
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.561035 15.1431H13.4837M9.68292 0.857422L12.7235 3.71456L4.36182 11.5717H1.32119V8.71456L9.68292 0.857422Z"
                      stroke="#2F80ED"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Edit
                </p>
                <p
                  v-if="pengguna.data.uid !== userData.uid"
                  @click="openCloseDeleteModal(true, pengguna.data.uid)"
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.571289 3.71456H13.4284M4.14272 3.71456V2.28599C4.14272 1.90711 4.29323 1.54375 4.56114 1.27584C4.82905 1.00793 5.19241 0.857422 5.57129 0.857422H8.42843C8.80731 0.857422 9.17068 1.00793 9.43858 1.27584C9.70649 1.54375 9.857 1.90711 9.857 2.28599V3.71456M11.9999 3.71456V13.7146C11.9999 14.0934 11.8494 14.4568 11.5814 14.7247C11.3135 14.9926 10.9502 15.1431 10.5713 15.1431H3.42843C3.04955 15.1431 2.68619 14.9926 2.41828 14.7247C2.15037 14.4568 1.99986 14.0934 1.99986 13.7146V3.71456H11.9999Z"
                      stroke="#EB5757"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Hapus
                </p>
              </div>
            </td>
          </tr>
          <!-- end iterasi tabel -->
        </table>
        <p
          v-if="!listPengguna || listPengguna.length === 0"
          class="empty-state-table"
        >
          Belum ada data
        </p>
      </div>
      <!-- end of tabel -->
    </div>

    <!-- modal input pengguna -->
    <ModalInput v-if="modalInputIsOpen">
      <div style="width: 730px" class="content">
        <h2>Tambah Pengguna</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- input nama karyawan -->
          <div style="position: relative" class="keterangan">
            <div ref="nama-form" class="box-form email">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="tambahPengguna.nama"
                  style="display: block"
                  class="input-title"
                  >Nama lengkap</span
                >
                <p
                  @click="openCloseModalPilihanNama(true)"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  {{
                    tambahPengguna.nama ? tambahPengguna.nama : "Nama lengkap"
                  }}

                  <svg
                    @click="clearInput"
                    v-if="tambahPengguna.nama"
                    style="margin-top: -13px; margin-right: -21px"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.3451 5.48011L12.9915 5.12655L12.638 5.48011L9.99984 8.11822L7.36172 5.48011L7.00817 5.12655L6.65462 5.48011L5.47962 6.65511L5.12606 7.00866L5.47962 7.36221L8.11773 10.0003L5.47962 12.6384L5.12606 12.992L5.47962 13.3455L6.65462 14.5205L7.00817 14.8741L7.36172 14.5205L9.99984 11.8824L12.638 14.5205L12.9915 14.8741L13.3451 14.5205L14.5201 13.3455L14.8736 12.992L14.5201 12.6384L11.8819 10.0003L14.5201 7.36221L14.8736 7.00866L14.5201 6.65511L13.3451 5.48011ZM9.99984 2.16699C14.332 2.16699 17.8332 5.66813 17.8332 10.0003C17.8332 14.3325 14.332 17.8337 9.99984 17.8337C5.66765 17.8337 2.1665 14.3325 2.1665 10.0003C2.1665 5.66813 5.66765 2.16699 9.99984 2.16699Z"
                      fill="#EB5757"
                      stroke="#EB5757"
                    />
                  </svg>
                </p>
              </div>
            </div>
            <!-- box pilihan nama -->
            <div
              v-if="listNonPengguna.length > 0"
              style="display: none"
              ref="pilihan-nama-modal"
              class="box-pilihan"
            >
              <p
                @click="openCloseModalPilihanNama(false, pengguna)"
                :key="pengguna.docId"
                v-for="pengguna in listNonPengguna"
              >
                {{ pengguna.data.dataDiri.namaLengkap }}
                <svg
                  v-if="
                    tambahPengguna.nama === pengguna.data.dataDiri.namaLengkap
                  "
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                    stroke="#00BA88"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </p>
            </div>
            <!-- end of box pilihan nama -->

            <!-- ketika ga ada pilihan nama -->
            <div
              v-else
              style="display: none"
              ref="pilihan-nama-modal"
              class="box-pilihan"
            >
              <p @click="openCloseModalPilihanNama(false, null)">
                Tidak ada calon pengguna
              </p>
            </div>
            <!-- end of ketika ga ada pilihan nama -->
          </div>
          <!-- end of input nama karyawan -->

          <!-- input email -->
          <div ref="email-form" class="box-form email">
            <svg
              width="18"
              height="16"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1429 2.71434C15.1429 1.92862 14.5 1.28577 13.7143 1.28577H2.28575C1.50003 1.28577 0.857178 1.92862 0.857178 2.71434M15.1429 2.71434V11.2858C15.1429 12.0715 14.5 12.7143 13.7143 12.7143H2.28575C1.50003 12.7143 0.857178 12.0715 0.857178 11.2858V2.71434M15.1429 2.71434L8.00003 7.71434L0.857178 2.71434"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="input-and-title">
              <span v-if="tambahPengguna.email" class="input-title">Email</span>
              <input
                v-model="tambahPengguna.email"
                class="input-text"
                required
                placeholder="Email"
                type="text"
              />
            </div>
          </div>
          <!-- end of input email -->

          <!-- input divisi -->
          <div style="position: relative" class="keterangan">
            <div ref="divisi-form" class="box-form email">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="tambahPengguna.divisi"
                  style="display: block"
                  class="input-title"
                  >Divisi</span
                >
                <p>
                  {{ tambahPengguna.divisi ? tambahPengguna.divisi : "Divisi" }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input divisi -->

          <!-- tanggal lahir -->
          <label
            ref="tanggal-lahir-form"
            tabindex="0"
            for="date-picker-lahir"
            class="box-form email"
          >
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style="position: relative" class="input-and-title">
              <span v-if="tambahPengguna.tanggalLahir" class="input-title"
                >Tanggal lahir</span
              >
              <p>
                {{
                  tambahPengguna.tanggalLahir
                    ? tambahPengguna.tanggalLahir
                    : "Tanggal lahir"
                }}
              </p>
            </div>
          </label>
        </div>
        <!-- end of input form -->
        <button
          @click="tambahkanData"
          :disabled="isProcessing"
          style="margin-left: 20px; margin-bottom: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text"> Tambahkan data</span>
        </button>
      </div>

      <!-- close button -->
      <svg
        style="margin-top: -210px"
        @click="openCLoseModalInput(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- end of modal input pengguna -->

    <!-- modal berhasil daftar pengguna -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65 32C65 29.8 63.2 28 61 28H29C26.8 28 25 29.8 25 32M65 32V56C65 58.2 63.2 60 61 60H29C26.8 60 25 58.2 25 56V32M65 32L45 46L25 32"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
        <p>
          Informasikan kepada karyawan agar mengecek inbox <br />
          email untuk melakukan pembuatan password akun
        </p>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasil(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil daftar pengguna -->

    <!-- modal delete pengguna -->
    <ModalDelete v-if="modalDeleteIsOpen">
      <div class="content">
        <!-- icon -->
        <svg
          style="margin-bottom: 22px"
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.5 88C68.8005 88 88.5 68.3005 88.5 44C88.5 19.6995 68.8005 0 44.5 0C20.1995 0 0.5 19.6995 0.5 44C0.5 68.3005 20.1995 88 44.5 88Z"
            fill="#EB5757"
          />
          <path
            d="M25.5356 30.8572H63.4642H25.5356ZM36.0714 30.8572V26.6429C36.0714 25.5252 36.5154 24.4533 37.3057 23.6629C38.096 22.8726 39.1679 22.4286 40.2856 22.4286H48.7142C49.8319 22.4286 50.9038 22.8726 51.6942 23.6629C52.4845 24.4533 52.9285 25.5252 52.9285 26.6429V30.8572H36.0714ZM59.2499 30.8572V60.3572C59.2499 61.4749 58.8059 62.5468 58.0156 63.3371C57.2253 64.1274 56.1533 64.5714 55.0356 64.5714H33.9642C32.8465 64.5714 31.7746 64.1274 30.9843 63.3371C30.1939 62.5468 29.7499 61.4749 29.7499 60.3572V30.8572H59.2499Z"
            stroke="#FCFCFC"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!-- end of icon -->

        <div class="text-modal">
          <h2 class="primary-text">Yakin untuk menghapus data?</h2>
          <p style="text-align: center">
            Data yang terhapus tidak bisa dikembalikan
          </p>

          <div class="list-button">
            <button @click="hapusData" class="delete">Hapus</button>
            <button @click="openCloseDeleteModal(false)" class="cancel">
              Batal
            </button>
          </div>
        </div>
      </div>

      <!-- close button -->
      <svg
        @click="openCloseDeleteModal(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalDelete>
    <!-- end of modal delete pengguna -->

    <!-- modal edit pengguna -->
    <ModalInput v-if="modalEditIsOpen">
      <div style="width: 730px" class="content">
        <h2>Edit Pengguna</h2>
        <!-- input form -->
        <div class="list-form-modal">
          <!-- input nama karyawan -->
          <div style="position: relative" class="keterangan">
            <div ref="nama-form" class="box-form email">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="chosenPengguna.nama"
                  style="display: block"
                  class="input-title"
                  >Nama lengkap</span
                >
                <p>
                  {{
                    chosenPengguna.nama ? chosenPengguna.nama : "Nama lengkap"
                  }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input nama karyawan -->

          <!-- input email -->
          <div ref="email-edit-form" class="box-form email">
            <svg
              width="18"
              height="16"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1429 2.71434C15.1429 1.92862 14.5 1.28577 13.7143 1.28577H2.28575C1.50003 1.28577 0.857178 1.92862 0.857178 2.71434M15.1429 2.71434V11.2858C15.1429 12.0715 14.5 12.7143 13.7143 12.7143H2.28575C1.50003 12.7143 0.857178 12.0715 0.857178 11.2858V2.71434M15.1429 2.71434L8.00003 7.71434L0.857178 2.71434"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="input-and-title">
              <span v-if="chosenPengguna.email" class="input-title">Email</span>
              <input
                v-model="chosenPengguna.email"
                class="input-text"
                required
                placeholder="Email"
                type="text"
              />
            </div>
          </div>
          <!-- end of input email -->

          <!-- input divisi -->
          <div style="position: relative" class="keterangan">
            <div ref="divisi-form" class="box-form email">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.857422 11.5717L8.00028 15.1431L15.1431 11.5717M0.857422 8.00028L8.00028 11.5717L15.1431 8.00028M8.00028 0.857422L0.857422 4.42885L8.00028 8.00028L15.1431 4.42885L8.00028 0.857422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div class="input-and-title">
                <span
                  v-if="chosenPengguna.divisi"
                  style="display: block"
                  class="input-title"
                  >Divisi</span
                >
                <p>
                  {{ chosenPengguna.divisi ? chosenPengguna.divisi : "Divisi" }}
                </p>
              </div>
            </div>
          </div>
          <!-- end of input divisi -->

          <!-- tanggal lahir -->
          <label
            ref="tanggal-lahir-form"
            tabindex="0"
            for="date-picker-lahir"
            class="box-form email"
          >
            <svg
              width="14"
              height="16"
              viewBox="0 0 14 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                stroke="#A0A3BD"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div style="position: relative" class="input-and-title">
              <span v-if="chosenPengguna.tanggalLahir" class="input-title"
                >Tanggal lahir</span
              >
              <p>
                {{
                  chosenPengguna.tanggalLahir
                    ? chosenPengguna.tanggalLahir
                    : "Tanggal lahir"
                }}
              </p>
            </div>
          </label>
        </div>
        <!-- end of input form -->
        <button
          :disabled="isProcessing"
          @click="editData"
          style="margin-left: 20px; margin-bottom: 20px"
          class="yellow-button"
        >
          <div ref="spinner" style="display: none" class="spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
          <span ref="button-text"> Simpan Data</span>
        </button>
      </div>

      <!-- close button -->
      <svg
        style="margin-top: -210px"
        @click="openCloseEditModal(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalInput>
    <!-- modal edit pengguna -->

    <!-- modal reset password -->
    <ModalPassword v-if="modalPasswordIsOpen">
      <div class="content">
        <!-- icon -->
        <svg
          style="margin-bottom: 10px"
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.5 88C68.8005 88 88.5 68.3005 88.5 44C88.5 19.6995 68.8005 0 44.5 0C20.1995 0 0.5 19.6995 0.5 44C0.5 68.3005 20.1995 88 44.5 88Z"
            fill="#FFB700"
          />
          <path
            d="M33.9638 41.393V32.9644C33.9638 30.1702 35.0738 27.4904 37.0497 25.5146C39.0255 23.5387 41.7053 22.4287 44.4995 22.4287C47.2938 22.4287 49.9736 23.5387 51.9494 25.5146C53.9252 27.4904 55.0352 30.1702 55.0352 32.9644V41.393H33.9638ZM29.7495 41.393H59.2495C61.577 41.393 63.4638 43.2798 63.4638 45.6073V60.3573C63.4638 62.6848 61.577 64.5716 59.2495 64.5716H29.7495C27.422 64.5716 25.5352 62.6848 25.5352 60.3573V45.6073C25.5352 43.2798 27.422 41.393 29.7495 41.393Z"
            stroke="#FCFCFC"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <!-- end of icon -->

        <div class="text-modal">
          <h2 class="primary-text">Yakin untuk reset password?</h2>
          <div class="list-button">
            <button
              @click="resetPassword"
              style="background-color: #ffb700"
              class="delete"
            >
              Ya
            </button>
            <button @click="openClosePasswordModal(false)" class="cancel">
              Batal
            </button>
          </div>
        </div>
      </div>

      <!-- close button -->
      <svg
        @click="openClosePasswordModal(false)"
        class="close-button"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
          stroke="#1D1D1D"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <!-- end of close button -->
    </ModalPassword>
    <!-- end of modal reset password -->

    <!-- modal berhasil reset password -->
    <ModalBerhasilReset v-if="modalBerhasilResetIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65 32C65 29.8 63.2 28 61 28H29C26.8 28 25 29.8 25 32M65 32V56C65 58.2 63.2 60 61 60H29C26.8 60 25 58.2 25 56V32M65 32L45 46L25 32"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Link reset password sudah dikirim</h2>
        <p>
          Informasikan kepada karyawan agar mengecek inbox email <br />
          untuk melakukan reset password akun
        </p>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalBerhasilReset(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasilReset>
    <!-- end of modal berhasil reset password -->
  </div>
</template>

<script>
import ModalInput from "@/components/modal/ModalInput";
import ModalBerhasil from "@/components/modal/ModalAlert";
import ModalBerhasilReset from "@/components/modal/ModalAlert";
import ModalDelete from "@/components/modal/Modal";
import ModalPassword from "@/components/modal/Modal";
import { mapState } from "vuex";
import * as soluhafire from "@/soluhafire";
import * as soluhaApi from "@/soluhaApi";

export default {
  components: {
    ModalInput,
    ModalBerhasil,
    ModalBerhasilReset,
    ModalDelete,
    ModalPassword,
  },

  data() {
    return {
      isProcessing: false,
      isFailed: false,
      // untuk index pengguna yg akan di hapus dan edit
      deletedUid: null,
      chosenIndex: null,
      resetedEmail: "",
      // pengguna yang akan diedit
      chosenPengguna: {
        nama: "",
        email: "",
        divisi: "",
        tanggalLahir: null,
        documentId: "",
      },
      // data untuk tambah pengguna
      tambahPengguna: {
        nama: "",
        email: "",
        divisi: "",
        tanggalLahir: null,
        documentId: "",
      },
      // status modal
      modalInputIsOpen: false,
      modalBerhasilIsOpen: false,
      modalBerhasilResetIsOpen: false,
      modalDeleteIsOpen: false,
      modalEditIsOpen: false,
      modalPasswordIsOpen: false,
      // filter
      filterData: {
        divisi: "semua",
        pencarian: "",
      },
    };
  },

  methods: {
    // untuk tutup atau buka box filter Divisi
    openClosePilihanDivisi(open, value) {
      let box = this.$refs.boxPilihanDivisi;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.divisi = value;
      }
    },

    openClosePilihanDivisiMobile(open, value) {
      let box = this.$refs.boxPilihanDivisiMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.divisi = value;
      }
    },

    // untuk tutup atau buka box modal bagian nama
    openCloseModalPilihanNama(open, pengguna) {
      let box = this.$refs["pilihan-nama-modal"];
      if (open) {
        box.style.display = "block";
      } else {
        if (!pengguna) {
          return;
        }
        box.style.display = "none";
        this.tambahPengguna.documentId = pengguna.docId;
        this.tambahPengguna.nama = pengguna.data.dataDiri.namaLengkap;
        this.tambahPengguna.divisi = pengguna.data.dataKepegawaian.divisi;
        this.tambahPengguna.tanggalLahir = pengguna.data.dataDiri.tanggalLahir;
      }
    },

    // modal tambah pegguna
    openCLoseModalInput(isOpen) {
      if (isOpen) this.modalInputIsOpen = true;
      else this.modalInputIsOpen = false;
    },

    // modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalInputIsOpen = false;
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    // untuk tutup atau buka modal
    openCloseDeleteModal(isOpen, uid) {
      if (isOpen) {
        this.deletedUid = uid;
        this.modalDeleteIsOpen = true;
      } else {
        this.openCloseAction(false, this.chosenIndex);
        this.modalDeleteIsOpen = false;
      }
    },

    // modal berhasil reset
    openCloseModalBerhasilReset(isOpen) {
      if (isOpen) {
        this.modalBerhasilResetIsOpen = true;
      } else {
        this.modalBerhasilResetIsOpen = false;
      }
    },

    openCloseEditModal(isOpen) {
      if (isOpen) {
        let index = this.chosenIndex;
        let pengguna = this.listPengguna[index];
        this.modalEditIsOpen = true;
        this.chosenPengguna.nama = pengguna.data.dataDiri.namaLengkap;
        this.chosenPengguna.email = pengguna.data.email;
        this.chosenPengguna.divisi = pengguna.data.dataKepegawaian.divisi;
        this.chosenPengguna.tanggalLahir = pengguna.data.dataDiri.tanggalLahir;
        this.chosenPengguna.documentId = pengguna.docId;
      } else {
        this.openCloseAction(false, this.chosenIndex);
        this.modalEditIsOpen = false;
      }
    },

    openClosePasswordModal(isOpen, email) {
      if (isOpen) {
        this.resetedEmail = email;
        this.modalPasswordIsOpen = true;
      } else {
        this.openCloseAction(false, this.chosenIndex);
        this.modalPasswordIsOpen = false;
      }
    },

    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    // validate email
    validateEmail(email) {
      let re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    // ketika salah input form
    failedInput() {
      this.isFailed = true;
    },

    async tambahkanData() {
      // cek apakah ada field yang kosong
      if (this.tambahPengguna.nama === "")
        this.$refs["nama-form"].classList.add("failed-box-form");
      else if (!this.validateEmail(this.tambahPengguna["email"]))
        this.$refs["email-form"].classList.add("failed-box-form");
      else {
        this.loader(true);
        await soluhafire.addEmailPengguna(
          this.tambahPengguna.documentId,
          this.tambahPengguna.email
        );
        this.loader(false);
        this.clearInput();
        this.openCloseModalBerhasil(true);
      }
    },

    openCloseAction(open, index) {
      let box = this.$refs["box-pilihan-aksi"][index];
      // tutup box action yang lain
      this.$refs["box-pilihan-aksi"].forEach((refs) => {
        refs.style.display = "none";
      });
      if (open) {
        box.style.display = "block";
        this.chosenIndex = index;
      } else {
        box.style.display = "none";
      }
    },

    hapusData() {
      soluhaApi.hapusPengguna(this.deletedUid);
      this.openCloseDeleteModal(false);
    },

    async editData() {
      // validasi email
      if (!this.validateEmail(this.chosenPengguna.email))
        this.$refs["email-edit-form"].classList.add("failed-box-form");
      else {
        this.loader(true);
        await soluhafire.addEmailPengguna(
          this.chosenPengguna.documentId,
          this.chosenPengguna.email
        );
        this.loader(false);
        this.chosenPengguna.documentId = "";
        this.chosenPengguna.nama = "";
        this.chosenPengguna.divisi = "";
        this.chosenPengguna.email = "";
        this.chosenPengguna.tanggalLahir = null;
        this.openCloseEditModal(false);
        this.openCloseModalBerhasil(true);
      }
    },

    async resetPassword() {
      await soluhaApi.resetPassword(this.resetedEmail);
      this.openCloseModalBerhasilReset(true);
      this.openClosePasswordModal(false);
    },

    clearInput() {
      this.tambahPengguna.documentId = "";
      this.tambahPengguna.nama = "";
      this.tambahPengguna.divisi = "";
      this.tambahPengguna.email = "";
      this.tambahPengguna.tanggalLahir = null;
    },

    loader(isLoading) {
      let textButton = this.$refs["button-text"];
      let spinner = this.$refs["spinner"];

      if (isLoading) {
        textButton.style.display = "none";
        spinner.style.display = "block";
        this.isProcessing = true;
      } else {
        textButton.style.display = "block";
        spinner.style.display = "none";
        this.isProcessing = false;
      }
    },
  },

  computed: {
    ...mapState(["listDivisi", "listKaryawan", "userData"]),

    listDivisiInput() {
      // remove "semua" dari list divisi yang akan dipilih
      let remove = "Semua";
      let divisi = this.listDivisi;
      divisi = divisi.filter((item) => item !== remove);
      return divisi;
    },

    listNonPengguna() {
      let nonPengguna = this.listKaryawan.filter((item) => !item.data.email);
      return nonPengguna;
    },

    listPengguna() {
      let pengguna = this.listKaryawan.filter(
        (item) => item.data.dataDiri && item.data.email && !item.data.isDeleted
      );
      let filterDivisi = this.filterData.divisi;
      let filterPencarian = this.filterData.pencarian.toLowerCase();
      if (filterDivisi === "semua") filterDivisi = "";

      return pengguna.filter(function (item) {
        let filtered = true;
        if (filterDivisi && filterDivisi.length > 0) {
          filtered = item.data.dataKepegawaian.divisi == filterDivisi;
        }
        if (filtered) {
          if (filterPencarian && filterPencarian.length > 0) {
            filtered = item.data.dataDiri.namaLengkap
              .toLowerCase()
              .includes(filterPencarian);
          }
        }
        return filtered;
      });
    },
  },
};
</script>

<style scoped>
.failed-box-form {
  border-color: #eb5757;
}

.failed-box-form * {
  color: #eb5757;
  stroke: #eb5757;
}
</style>
